import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';
import * as moment from 'moment';

import { ActivatedRoute } from '@angular/router';

import { Account, LoginModalService, Principal, CARD_UNLIMITED_BOOKINGS_NUMBER, BackOfficeService } from '../shared';

import { NewsArticle } from '../entities/news-article/news-article.model';
import { NewsArticleService } from '../entities/news-article/news-article.service';
import { SchoolCalendar, SchoolCalendarService} from '../entities/school-calendar';
import { School, SchoolService} from '../entities/school';
import { Student, StudentService, StudentUtilService } from '../entities/student';
import { Event, EventService } from '../entities/event';

import { Card, CardService } from '../entities/card';
import { StudentComment, StudentCommentService } from '../entities/student-comment';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {DEFAULT_FACEBOOK_URL, DEFAULT_INSTAGRAM_URL, DEFAULT_TIKTOK_URL,
    DEFAULT_YOUTUBE_URL, DEFAULT_WEBSITE_URL, DEFAULT_MAILTO, DEFAULT_TELEPHONE} from '../shared/constants/layout.constants';

@Component({
    selector: 'jhi-home',
    templateUrl: './home.component.html',
    styleUrls: [
        'home.scss'
    ]

})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit   {
    account: Account;
    student: Student;
    currentSchoolCalendar: SchoolCalendar = new SchoolCalendar();
    modalRef: NgbModalRef;
    currencyCode: string = 'EUR'; // Euro ISO 4217 code
    activeCards: Card [] = [];
    currentSchool: School;
    news: NewsArticle[] = [];
    comments: StudentComment[] = [];
    websiteUrl: string = DEFAULT_WEBSITE_URL;
    facebookUrl: string = DEFAULT_FACEBOOK_URL;
    instagramUrl: string = DEFAULT_INSTAGRAM_URL;
    mailTo: string = 'mailto:' + DEFAULT_MAILTO;
    youtubeUrl: string  = DEFAULT_YOUTUBE_URL;
    tiktokUrl: string = DEFAULT_TIKTOK_URL;
    telephone: string = null;

    highlightedevents: Event[] = [];
    maxHighlightedItems: any;

    hasAdminRights: boolean = false;
    hasTeacherRole: boolean = false;

    // variables to show info cards
    studentCurrentCardInfoLoaded: boolean = false;
    schoolOnlinePaymentsCardInfoLoaded: boolean = false;

    // variables to show the booking window
    bookingWindow: number;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private loginModalService: LoginModalService,
        private eventManager: EventManager,
        private alertService: AlertService,
        private schoolCalendarService: SchoolCalendarService,
        private schoolService: SchoolService,
        private studentService: StudentService,
        private studentCommentService: StudentCommentService,
        private studentUtilService: StudentUtilService,
        private cardService: CardService,
        private eventService: EventService,
        private newsArticleService: NewsArticleService,
        private route: ActivatedRoute,
        private backOfficeService: BackOfficeService
    ) {
        this.jhiLanguageService.setLocations(['home', 'student',
                                                'card', 'cardType',
                                                'newsArticle', 'student-comment',
                                                'event']);
    }

    ngOnInit() {
        this.maxHighlightedItems = 3;
        this.hasAdminRights = false;
        this.hasTeacherRole = false;
        this.studentCurrentCardInfoLoaded = false;
        this.schoolOnlinePaymentsCardInfoLoaded = false;

        this.principal.identity().then((account) => {
            this.account = account;
        });

        this.loadCurrentSchool();
        this.loadSchoolCalendar();
        this.loadRoles();
        this.loadCurrentStudent();
        this.registerAuthenticationSuccess();
    }

    loadSchoolCalendar() {
        this.principal
            .hasAnyAuthority(['ROLE_SCHOOL_ADMIN' ])
            .then(response => {
                if (response) {

                    this.hasAdminRights = true;

                    // we load the calendars to show the message to the admin
                    this.schoolCalendarService
                    .current()
                    .subscribe(
                        (res: HttpResponse<SchoolCalendar[]>) => {
                            let calendars = res.body;
                            if (calendars.length > 0 ) {
                                this.currentSchoolCalendar = calendars[0];
                            } else {
                                this.currentSchoolCalendar = null;
                            }
                        },
                        (res: HttpErrorResponse) => this.onError(res));
                }
            });
    }

    loadRoles() {
        this.principal
        .hasAnyAuthority(['ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ])
        .then(response => {
            if (response) {
                this.hasTeacherRole = true;
            }
        });
    }

    ngAfterViewInit() {
       // Nothing to do
    }

    public startAccountOnboardingSession() {
        if (!this.currentSchool) {
            return;
        }

        this.backOfficeService
            .createOrResumeCreateBackofficeAccount(this.currentSchool)
            .subscribe( (chechoutUrl: string) => {
                // we open the onboarding page in same browser so the user can pay
                window.location.href = chechoutUrl;
            } , (error: HttpErrorResponse) => console.log('Error onboarding the account: Unexpected error from the server'));
    }

    onlinePaymentEnabled () {
        return this.currentSchool &&
                this.currentSchool.acceptOnlinePayments &&
                this.currentSchool.onlinePaymentsModuleEnabled &&
                this.currentSchool.backofficeAccountId;
    }

    private loadCurrentSchool() {
         this.schoolService
            .findCurrent()
            .subscribe(school => {
            this.currentSchool = school;
            this.schoolOnlinePaymentsCardInfoLoaded = true;

            if (this.currentSchool) {
                this.facebookUrl = this.currentSchool.facebookUrl;
                this.instagramUrl = this.currentSchool.instagramUrl;
                this.youtubeUrl = this.currentSchool.youtubeUrl;
                this.tiktokUrl = this.currentSchool.tiktokUrl;
                this.websiteUrl = this.currentSchool.websiteUrl;
                this.telephone  = 'tel:' + this.currentSchool.supportPhone;
                this.mailTo = 'mailto:' + this.currentSchool.supportEmail;
            }
            this.loadHighlightedEvents();
            this.tryLoadBookingWindow();
            }, e => this.onError(e));
    }


    private loadCurrentStudent() {
        this.studentService.getCurrent().subscribe(
            (student: Student) => {
                this.student = student;
                this.loadComments();
                this.tryLoadBookingWindow();
                this.loadActiveCards(student.id);
                this.loadNews();

            },
            (res: HttpErrorResponse) => this.onError(res));
    }

    loadActiveCards(studentId: number) {
        const today = moment().format('YYYY-MM-DD');
        const query = `validSince:[* TO ${today}] AND validUntil:[${today} TO *] AND student.id:${studentId}`;
        this.cardService.search({ query: query })
        .subscribe((response: HttpResponse<Card[]>) => {
            this.activeCards = response.body || [];
            this.studentCurrentCardInfoLoaded = true;
        },
        (error) => {
            this.onError(error);
        });
    }

    tryLoadBookingWindow(): void {
        if (this.currentSchool && this.student) {
            this.bookingWindow = this.studentUtilService.getBookingWindow(this.currentSchool, this.student);
            return;
        }
        this.bookingWindow = 0;
    }

    loadHighlightedEvents() {
        const query = 'highlighted:true AND NOT status:DRAFT AND school.id:' + this.currentSchool.id;

        this.eventService.search({
            query,
            size: this.maxHighlightedItems,
            sort: 'begining,asc'
        }).subscribe(
            (res: HttpResponse<Event[]>) => {
                this.onHighlightedEventsSuccess(res.body, res.headers);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    private onHighlightedEventsSuccess(data, headers) {
        this.highlightedevents = data;
    }

    private comesFromSuccessOnboardingSession() {
        let onboardingSuccess = this.route.snapshot.queryParams['onboarding']
        ?  this.route.snapshot.queryParams['onboarding']
        : null;
        return onboardingSuccess === 'success';
    }

    private comesFromIncompleteOnboardingSession() {
        let onboardingSuccess = this.route.snapshot.queryParams['onboarding']
        ?  this.route.snapshot.queryParams['onboarding']
        : null;
        return onboardingSuccess === 'incomplete';
    }

    public showCurrentCalendarWarning() {
        return this.currentSchoolCalendar === null;
    }

    public showActiveCardsInfo(): boolean {
        return this.activeCards != null && this.activeCards.length >= 1 ;
    }

    public getAvailableAssistances(card: Card): number {
        return this.cardService.getAvailableAssistances(card);
    }

    public getStatusBadgeStyle(percentage: number): string {
        return this.studentUtilService.getStatusBadgeStyle(percentage);
    }

    registerAuthenticationSuccess() {
        this.eventManager.subscribe('authenticationSuccess', (message) => {
            this.principal.identity().then((account) => {
                this.activeCards = [];
                this.studentCurrentCardInfoLoaded = false;
                this.schoolOnlinePaymentsCardInfoLoaded = false;
                this.hasAdminRights = false;
                this.hasTeacherRole = false;
                this.highlightedevents = [];
                this.account = account;
                this.loadCurrentSchool();
                this.loadSchoolCalendar();
                this.loadRoles();
                this.loadCurrentStudent();
            });
        });
    }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    login() {
        this.modalRef = this.loginModalService.open();
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }

    loadNews() {
        this.newsArticleService.findValidByDate({showInHomePage: true}).subscribe(
            (res: HttpResponse<NewsArticle[]>) => this.onNewsSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    loadComments() {
        this.studentCommentService.search({
            query: 'student.id:' + this.student.id + ' AND status:OPEN',
            sort: ['createdDate,desc'],
            size : 10
        }).subscribe(
            (res: HttpResponse<StudentComment[]>) => this.comments = res.body,
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    onNewsSuccess(response: any, headers): void {
        this.news = response;
    }

    ngOnDestroy() {
        this.comments = [] ;
    }

    openHelpLink() {
        if (this.currentSchool.helpUrl) {
            window.open(this.currentSchool.helpUrl);
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.component.ts